export default {
  NONE: "syncType_NONE",
  CREATE: "syncType_CREATE",
  IGNORE: "syncType_IGNORE"
};
